import { render } from "./asset-assignments.vue?vue&type=template&id=23f952b8"
import script from "./asset-assignments.vue?vue&type=script&lang=js"
export * from "./asset-assignments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__